import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import RajAirTracking from './Tracking/RajAirTracking';
import JaimarutiTraking from './Tracking/JaimarutiTraking';
import ShreeramjiTracking from './Tracking/ShreeramjiTracking';




// import Pincode from './Pincodefinder/Pincode';


function App() {
  return (
    <Router>
      <div>
        {/* Other components */}
        <Routes>
          {/* Define routes for Pincode and Tracking */}
          {/* <Route path="/pincode" element={<Pincode />} /> */}
   
          
            {/* <Route path="/RajAirTracking" element={<RajAirTracking />} />  */}
               <Route path="/JaimarutiTraking" element={<JaimarutiTraking />} /> 
               <Route path="/ShreeramjiTracking" element={<ShreeramjiTracking />} /> 
        
        
                {/* <Route path="/tracking" element={<Progresss />} /> */}
        </Routes>
        {/* Other components */}
      </div>
    </Router>
  );
}

export default App;
